<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :vislble-alert="true"
      field-name="발생 사업장"
    />

    <!-- 점검 정보 -->
    <div>
      <h5 class="my-4"><i class="dot"></i> 점검 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div class="form-title">기관</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.기관 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.기관" :max="100"/>
        </div>
        <div>
          <div class="form-title">점검사유</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.점검사유 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.점검사유" :max="100"/>
        </div>
        <div>
          <div class="form-title">주요 점검내용</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.주요_점검내용 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.주요_점검내용" :max="100"/>
        </div>

        <div>
          <div class="form-title">점검일(발생일)</div>
          <p v-if="isPrint" class="print-input">{{ form.발생일 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.발생일" />
        </div>
        <div>
          <div class="form-title">자체점검 요청기한</div>
          <p v-if="isPrint" class="print-input">{{ form.자체점검요청기한 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.자체점검요청기한" />
        </div>
        <div>
          <div class="form-title">자체개선 요청기한</div>
          <p v-if="isPrint" class="print-input">{{ form.자체개선요청기한 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.자체개선요청기한" />
        </div>
      </div>
    </div>

    <div>
      <h5 class="my-4"><i class="dot"></i> 개선조치 및 보고</h5>
      <div class="writeGridContainer">
        <div>
          <div class="form-title">수검 사업장 개선조치</div>
          <p v-if="isPrint" class="print-input">{{ form.수검사업장개선조치 }}</p>
          <vs-select v-model="form.수검사업장개선조치" autocomplete v-else :readonly="board.readonly">
            <vs-select-item text="미완료" value="미완료" />
            <vs-select-item text="완료" value="완료" />
          </vs-select>
        </div>
        <div>
          <div class="form-title">경영책임자 보고</div>
          <p v-if="isPrint" class="print-input">{{ form.경영책임자_보고 }}</p>
          <vs-select v-model="form.경영책임자_보고" autocomplete v-else :readonly="board.readonly">
            <vs-select-item text="미완료" value="미완료" />
            <vs-select-item text="완료" value="완료" />
          </vs-select>
        </div>
        <div>
          <div class="form-title">보고일</div>
          <p v-if="isPrint" class="print-input">{{ form.보고일 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.보고일" />
        </div>
      </div>
    </div>

    <table-custom
      :board="board"
      :is-print="isPrint"
      :controls="false"
      :multiple="false"
      :tableData="[
        { id: 'fieldName', title: '사업장명', type: 'text', readonly: true, },
        // { id: 'take', title: '개선조치 여부', type: 'select', selectData: ['비대상', '미완료', '완료'] },
        { id: 'takeDate', title: '조치일', type: 'date', placeholder: '', },
          { id: 'progress', title: '진행상태', type: 'customType'},
        { id: 'etc', title: '비고', type: 'text', placeholder: '', max: 200 },
      ]"
      :mobile="['fieldName', 'take']"
      v-model="form.개선조치현황"
      class="mt-28px"
    >
      <template #customType="{ row, index }">
        <custom-option-selector
          v-model="form.개선조치현황[index].progress"
          :options="['비대상', '1차제출', '최종제출', '적용대상 없음', '특이사항 없음', '직접입력']"
          :readonly="board.readonly"
          :addableOption="true"
          class="w-full"
        />
      </template>
    </table-custom>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import TableCustom from "@/components/TableCustom.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";

export default {
  components: {
    CustomOptionSelector,
    DateSelector,
    DisasterClassSelector,
    CompanySelector,
    TableCustom,
    NameWithSignatureRow,
    PhotoUploadGridModule,
    SignField,
    TableInspectMerge,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    targetCompany (value) {
      this.form.companyName = value.com_name
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],

        기관: "",
        점검사유: "",
        주요_점검내용: "",
        발생일: "",
        자체점검요청기한: "",
        자체개선요청기한: "",

        수검사업장개선조치: "",
        경영책임자_보고: "",
        보고일: "",
        개선조치현황: [
          { "id": 1, "fieldName": "인천공장", "take": "", "takeDate": "", "progress": "", "etc": "" },
          { "id": 2, "fieldName": "포항공장", "take": "", "takeDate": "", "progress": "", "etc": "" },
          { "id": 3, "fieldName": "당진공장", "take": "", "takeDate": "", "progress": "", "etc": "" },
          { "id": 4, "fieldName": "중앙기술연구소", "take": "", "takeDate": "", "progress": "", "etc": "" },
        ],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.form-title {
  word-break: keep-all;
}
</style>

